import { useState } from 'react';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { lazy } from '@sorare/core/src/lib/retry';

const PendingPackReveal = lazy(
  async () =>
    import('@sorare/marketplace/src/components/commonCard/PendingPackReveal/index.tsx'),
  'PendingPackReveal'
);

export const ClaimablePacksReveal = () => {
  const { currentUser } = useCurrentUserContext();

  const [packIds, setPackIds] = useState<string[]>();

  const claimablePacksIds =
    currentUser?.claimablePacks.map(pack => pack.id) || [];

  if (!packIds && claimablePacksIds.length) {
    setPackIds(claimablePacksIds);
  }

  const currentPackId = packIds?.at(0);
  if (!currentPackId) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <PendingPackReveal
        key={currentPackId}
        packId={currentPackId}
        onDone={() => setPackIds(previous => previous?.slice(1) ?? [])}
      />
    </Suspense>
  );
};
